module.exports = __webpack_public_path__ + "img/build4.9f7fce22.png";